import React, { Component }  from 'react';
import styled from "styled-components";


const ImgDiv = styled.img`
    width: 100%;
    max-width: 100%;
    height: auto;
    display: block;
    margin: 0 auto;
    
    @media only screen and (max-width: 750px) {
        width: 90%;
        max-width: 90%;
        margin: 0 auto;
    }
    
    @media only screen and (max-width: 480px) {
        width: 85%;
        max-width: 85%;
        margin: 0 auto;
    }
`


const Img = (props) =>{
    const {src, alt} = props
    return <ImgDiv
                src={src}
                alt={alt}
            />
}

export default Img